<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Hour Meter Counter (AT+GTHMC)</span>
        </div>
      </div>
    </p-header>
  
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Enable hour meter" [(ngModel)]="hmcParameters.enable">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
  
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Initial Hour Meter Count">
            </form-input>
          </div>
          <div class="col">
            <input type="text" pInputText [(ngModel)]="hmcParameters.hourMeterCount" maxlength="11" class="txtbStyle"/>
          </div>
        </div>
    </div>
  </p-accordionTab>